import { createFeatureSelector, createSelector } from '@ngrx/store'
import { EVisitorState, EVisitorStatusType } from './evisitor.model'

export const selectEVisitorState = createFeatureSelector<EVisitorState>('evisitor')

// Select status for a specific booking
export const selectEVisitorStatusByBooking = (bookingId: string) =>
  createSelector(selectEVisitorState, (state: EVisitorState) => {
    return state?.statuses?.[bookingId] || null
  })

// Check if operation is pending for a booking
export const selectIsEVisitorOperationPending = (bookingId: string) =>
  createSelector(selectEVisitorState, (state: EVisitorState) => {
    return state?.pendingOperations?.[bookingId] || false
  })

// Get error for a booking
export const selectEVisitorError = (bookingId: string) =>
  createSelector(selectEVisitorState, (state: EVisitorState) => {
    return state?.error?.[bookingId] || null
  })

// Check if can send to eVisitor (not sent yet or error state)
export const selectCanSendToEVisitor = (bookingId: string) =>
  createSelector(selectEVisitorStatusByBooking(bookingId), (status) => {
    if (!status) return true // Not sent yet
    return (
      status.status === EVisitorStatusType.NotSent ||
      status.status === EVisitorStatusType.Error ||
      status.status === EVisitorStatusType.Canceled
    )
  })

// Check if can deregister (must be sent first)
export const selectCanDeregister = (bookingId: string) =>
  createSelector(selectEVisitorStatusByBooking(bookingId), (status) => {
    return status?.status === EVisitorStatusType.Sent && !!status?.referenceId
  })

// Check if can cancel (must be sent and not deregistered)
export const selectCanCancel = (bookingId: string) =>
  createSelector(selectEVisitorStatusByBooking(bookingId), (status) => {
    return (
      (status?.status === EVisitorStatusType.Sent || status?.status === EVisitorStatusType.Deregistered) &&
      !!status?.referenceId
    )
  })
